<template>
    <div>
        <h1>RENJA PENGELUARAN</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
